<template>
  <div class="shoppe">
    <h2>订单</h2>
    <p class="mt10"><el-link type="primary" @click="openPage('/productTrace/order-push')">重推订单</el-link></p>

    <h2 class="mt20">商品信息</h2>
    <p class="mt10"><el-link type="primary" @click="openPage('/productTrace/product')">商品更新历史</el-link></p>

    <h2 class="mt20">折扣历史</h2>
    <el-tabs class="mt10" v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="活动折扣历史" name="promotion"></el-tab-pane>
      <el-tab-pane label="日常折扣历史" name="daily"></el-tab-pane>
    </el-tabs>
    <el-form label-position="right" label-width="60px">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="买手店">
                <el-select v-model="queryForm.vendorId" @change="onChangeVendor" filterable clearable>
                  <el-option v-for="item in (activeName === 'promotion' ? vendorList : vendorList2)" :label="item.label" :value="item.value" :key="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" v-if="activeName === 'promotion'">
              <el-form-item label="活动">
                <el-select v-model="queryForm.promotionId" :loading="promotionListLoading" filterable clearable>
                  <el-option v-for="item in promotionList" :label="item.promotionTitle" :value="item.promotionId" :key="item.promotionId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
          <el-button @click="search" type="primary">查询</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-table :data="tableData">
      <el-table-column key="vendorName1" prop="vendorName" label="店铺" v-if="activeName === 'promotion'">
        <template slot-scope="scope">
          {{ vendorMap[scope.row.vendorId] }}
        </template>
      </el-table-column>
      <el-table-column key="categoryType1" prop="categoryType" label="类目" v-if="activeName === 'promotion'">
        <template slot-scope="scope">
          {{ scope.row.appropriateType === 1 ? '成人' : '儿童' }}
        </template>
      </el-table-column>
      <el-table-column key="seasonCode1" prop="seasonCode" label="季节" v-if="activeName === 'promotion'">
        <template slot-scope="scope">
          {{ scope.row.seasonCode }}{{ scope.row.coFlag ? '(CO)' : '' }}
        </template>
      </el-table-column>
      <el-table-column key="promotionTitle" prop="promotionTitle" label="活动名称" v-if="activeName === 'promotion'"></el-table-column>
      <el-table-column prop="startAt" label="开始时间" v-if="activeName === 'promotion'"></el-table-column>
      <el-table-column prop="endAt" label="结束时间" v-if="activeName === 'promotion'"></el-table-column>

      <el-table-column key="vendorName2" prop="vendorName" label="店铺" v-if="activeName === 'daily'"></el-table-column>
      <el-table-column key="categoryType2" prop="categoryType" label="类目" v-if="activeName === 'daily'"></el-table-column>
      <el-table-column key="seasonCode2" prop="seasonCode" label="季节" v-if="activeName === 'daily'">
        <template slot-scope="scope">
          {{ scope.row.seasonCode }}{{ scope.row.coFlag ? '(CO)' : '' }}
        </template>
      </el-table-column>
      <el-table-column prop="activeTime" label="历史生效时间" v-if="activeName === 'daily'"></el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-link type="primary" @click="exportItem(scope.row)">下载</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>


  </div>
</template>

<script>
import { downloadUrlFile } from '../../../utils/functions';
import utils from '@/utils/util';
import {
  getVendorsByVendorName,
} from '../../discount/api';
import {
  queryVendor,
  getVendorPromotionList,
  getVendorPromotionDiscountList,
  exportVendorPromotionDiscount,
  getTaskManageList,
} from "../../../api/trace";

export default {
  components: {
  },
  data() {
    return {
      vendorList: [],
      vendorMap: {},
      vendorList2: [],
      productId: '',
      activeName: 'promotion',
      promotionListLoading: false,
      promotionList: [],
      queryForm: {
        vendorId: null,
        promotionId: null,
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
    };
  },
  mounted() {
    queryVendor(true).then(res => {
      if (res.data && res.data.data) {
        const map = {};
        this.vendorList = res.data.data.map(item => {
          map[item.vendorId] = item.vendorName;
          return {
            label: item.vendorName,
            value: item.vendorId,
          };
        });
        this.vendorMap = map;
      }
    });
    getVendorsByVendorName({vendorId:''}).then(res => {
      this.vendorList2 = (res.data || []).map(item => {
        return {
          label: item.vendorName,
          value: item.vendorId,
        };
      });
    })
  },
  methods: {
    openPage(url) {
      window.open(`/#${url}`)
    },
    openProductDetail() {
      if (!this.productId) {
        this.$message.error('请输入商品ID');
        return;
      }
      this.openPage('/productManagement/detail/'+this.productId+'/0');
      this.productId = '';
    },
    handleClick() {
      this.queryForm.vendorId = null;
      this.queryForm.promotionId = null;
      this.promotionList = [];
      this.tableData = [];
    },
    onChangeVendor(val) {
      this.queryForm.promotionId = null;
      this.promotionList = [];
      if (val && this.activeName === 'promotion') {
        this.promotionListLoading = true;
        getVendorPromotionList(val).then(res => {
          if (res.data && res.data.data) {
            this.promotionList = res.data.data;
          }
          this.promotionListLoading = false;
        });
      }
    },
    search() {
      if (!this.queryForm.vendorId) {
        this.$message.error('请选择买手店');
        return;
      }
      if (this.activeName === 'promotion' && !this.queryForm.promotionId) {
        this.$message.error('请选择活动');
        return;
      }
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      if (this.activeName === 'promotion') {
        getVendorPromotionDiscountList(this.queryForm).then(res => {
          if (res.data && res.data.data) {
            this.total = res.data.data.total;
            this.tableData = res.data.data.list || [];
          }
        })
      } else {
        getTaskManageList({
          ...this.queryForm,
          taskCode: 'price_change_rule_active',
          status: 1,
          isNullComments: false,
        }).then(res => {
          if (res.data && res.data.data) {
            this.total = res.data.data.total;
            this.tableData = (res.data.data.list || []).map(item => {
              const data = JSON.parse(item.data);
              data.activeTime = utils.dateFormat(new Date(data.activeTime), 'yyyy-MM-dd hh:mm:ss');
              return data;
            });
          }
        })
      }
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    exportItem(row) {
      if (this.activeName === 'promotion') {
        exportVendorPromotionDiscount(row.salesPromotionVendorRuleHistoryId).then(res => {
          if (res.data && res.data.data) {
            downloadUrlFile(res.data.data)
          }
        })
      } else {
        downloadUrlFile(row.fileUrl);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
  font-size: 14px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.mt10 {
  margin-top: 10px;
}
.mt20 {
  margin-top: 20px;
}
</style>
